export default "__VITE_ASSET__Bv7nnG4z__";